<div class="card-wrapper">
  <mat-card appearance="outlined">
    <mat-card-title class="small-card-title"
      >Common first tasks:</mat-card-title
    >
    <mat-card-content>
      <mat-nav-list>
        <a mat-list-item [routerLink]="['/organization', 'users']"
          >Setup users</a
        >
        <a mat-list-item [routerLink]="['/profile']">Update your profile</a>
      </mat-nav-list>
    </mat-card-content>
  </mat-card>
</div>
